<template>
  <div>
    <div class="map" ref="map"></div>
    <div class="pano" ref="pano" :class="this.showHideSeat ? 'show' : ''"></div>
    <button v-if="showPrevious && !showHideSeat" class="back map" @click="previousMap">
      <img src="@/assets/icons/back.svg" alt />
    </button>
    <button v-if="showHideSeat" class="back seat" @click="hideSeat">
      <img src="@/assets/icons/back.svg" alt />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    view: String,
  },
  data() {
    return {
      currentMap: "",
      showPrevious: false,
      showHideSeat: false,
      maps: [],
      Viewer: undefined,
      Viewer3d: undefined,
      venue_id: "nam-us-00098-fccincinnati",
      seatExceptions: ["thebailey", "S_"],
      sections: {
        tunnelclub: [
          "S_F1",
          "S_F2",
          "S_F3",
          "S_F4",
          "S_F5",
          "S_F6",
          "S_F7",
          "S_F8",
          "S_F9",
        ],
        reservedseating: [
          "S_101",
          "S_102",
          "S_103",
          "S_104",
          "S_105",
          "S_111",
          "S_112",
          "S_113",
          "S_114",
          "S_122",
          "S_123",
          "S_124",
          "S_125",
          "S_126",
          "S_127",
          "S_128",
          "S_129",
          "S_130",
          "S_131",
          "S_133",
          "S_133",
          "S_134",
          "S_206",
          "S_210",
          "S_211",
          "S_212",
          "S_213",
          "S_214",
          "S_215",
          "S_216",
          "S_217",
          "S_218",
          "S_219",
          "S_220",
          "S_221",
          "S_222",
          "S_223",
          "S_224",
          "S_225",
          "S_226",
          "S_227",
          "S_228",
          "S_229",
          "S_230",
          "S_231",
          "S_232",
          "S_233",
          "S_234",
        ],
        thebailey: ["S_106", "S_107", "S_108", "S_109", "S_110"],
        pitchviewclub: ["S_W4", "S_W5", "S_W6"],
        cincinnatusclub: ["S_W1", "S_W2", "S_W3", "S_W7", "S_W8", "S_W9"],
        firstfinancialclub: [
          "S_E1",
          "S_E2",
          "S_E3",
          "S_E4",
          "S_E5",
          "S_E6",
          "S_E7",
        ],
      },
    };
  },
  mounted() {
    const viewer_input_options = {
      container: this.$refs.map,
      callbacks: {
        click: this.onClickNode,
      },
    };
    const input_options = {
      container: this.$refs.pano,
      venue_id: this.venue_id,
    };

    const viewer_promise = window.DVM.loadModule(
      "map_viewer",
      viewer_input_options
    );
    const viewer3d_promise = window.DVM.loadModule("3d_viewer", input_options);

    Promise.all([viewer_promise, viewer3d_promise])
      .then(this.onLoadModules)
      .catch(function (err) {
        console.error(err);
      });
  },
  methods: {
    onLoadModules(result) {
      this.Viewer = result[0];
      this.Viewer3d = result[1];
      let map = "blockmap";
      if (this.view == "thebailey" || this.view == "reservedseating") {
        map = "blockmap_bowl";
      }
      this.showMap(map);
    },
    showMap(_map) {
      var load_options = {
        venue_id: this.venue_id,
        map_id: _map,
      };

      this.Viewer.loadMap(load_options)
        .then(this.onLoadMap)
        .catch(function (err) {
          console.error(err);
        });
    },
    onLoadMap(obj) {
      this.Viewer.flags.automatic_selection = false;
      this.Viewer.max_selection = 1;
      this.Viewer.setAvailability("section", this.sections[this.view]);
      const allSeats = this.Viewer.getNodesByType("seat");

      if (this.currentMap !== "") {
        let sectionSeats = [];
        for (let index = 0; index < allSeats.length; index++) {
          const element = allSeats[index];
          const elementIdArray = element.id.split("-");
          if (elementIdArray[0] === this.currentMap) {
            sectionSeats.push(element.id);
          }
        }
        this.Viewer.setAvailability("seat", sectionSeats);
      }
    },
    showSeat() {
      this.showHideSeat = true;
    },
    onClickNode(obj) {
      var node = obj.nodes[0];
      if (node) {
        if (
          node.type === "seat" ||
          (this.seatExceptions !== undefined &&
            this.seatExceptions.includes(this.view))
        ) {
          if (node.state === "available") {
            this.Viewer.unselectAll();
            this.Viewer.select(node);
            this.Viewer3d.loadView3d({
              venue_id: this.venue_id,
              view_id: node.id,
            })
              .then(this.showSeat)
              .catch(function (err) {
                // Error while loading
                console.error(err);
              });
          } else if (node.state === "selected") {
            this.Viewer.unselect(node);
          }
        } else {
          this.maps.push(node.id);
          this.currentMap = node.id;
          this.showMap(node.id);
          this.showPrevious = true;
        }
      }
    },
    previousMap(e) {
      if (this.maps.length == 0) {
        return;
      }
      var _lastMap = this.maps[this.maps.length - 2];
      if (_lastMap === undefined) {
        _lastMap = "blockmap";
        if (this.view == "thebailey" || this.view == "reservedseating") {
          _lastMap = "blockmap_bowl";
        }
      }
      this.maps.pop();
      this.currentMap = "";
      this.showMap(_lastMap);

      if (this.maps.length == 0) {
        this.showPrevious = false;
        return;
      }
    },
    hideSeat(e) {
      this.showHideSeat = false;
    },
  },
};
</script>

<style lang="scss">
/*.map > div {
  height: 100% !important;
}*/
</style>
<style lang="scss" scoped>
.pano,
.map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.pano {
  opacity: 0;
  transition: opacity 0.2s;
  pointer-events: none;
  &.show {
    opacity: 1;
    pointer-events: all;
  }
}
.back {
  position: absolute;
  top: 50px;
  left: 50px;
  z-index: 1;
  background: black;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>